import { useForm as useFormHook } from "hooks";
import type { Setup as SetupType } from "features/setups/types";
import {
    type SetupForm,
    type Setup,
    FormField
} from "./types";
import { SetupValueFactory } from "./SetupValue";
import useValidationSchema from "./useValidationSchema";

export const getInitialValues = (setup: SetupType<string>): Setup => ({
    ...setup,
    [FormField.SetupInputValue]: '',
    setupValue: SetupValueFactory.make()
        .init(setup)
});

export const useForm = (setupForm: SetupForm) =>
    useFormHook({
        ...setupForm,
        validateOnMount: true,
        validationSchema: useValidationSchema()
    });
